
      // Avoid loading external analytics/guide scripts in dev to prevent noisy console errors.
      if (import.meta.env.PROD) {
        window.dataLayer = window.dataLayer || [];

        const loadThirdPartyScripts = () => {
          const gtmId = "";
          if (gtmId) {
            (function (w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ "gtm.start": new Date().getTime(), "event": "gtm.js" });
              var f = d.getElementsByTagName(s)[0];
              var j = d.createElement(s);
              var dl = l != "dataLayer" ? "&l=" + l : "";
              j.async = true;
              j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, "script", "dataLayer", gtmId);
          }

          (function (g, u, i, d, e, s) {
            g[e] = g[e] || [];
            var f = u.getElementsByTagName(i)[0];
            var k = u.createElement(i);
            k.async = true;
            k.src = "https://static.userguiding.com/media/user-guiding-" + s + "-embedded.js";
            f.parentNode.insertBefore(k, f);
            if (g[d]) return;
            var ug = (g[d] = { q: [] });
            ug.c = function (n) {
              return function () {
                ug.q.push([n, arguments]);
              };
            };
            var m = [
              "previewGuide",
              "finishPreview",
              "track",
              "identify",
              "hideChecklist",
              "launchChecklist",
            ];
            for (var j = 0; j < m.length; j += 1) {
              ug[m[j]] = ug.c(m[j]);
            }
          })(window, document, "script", "userGuiding", "userGuidingLayer", "LXI85127AXJID");
        };

        if ("requestIdleCallback" in window) {
          requestIdleCallback(loadThirdPartyScripts, { timeout: 5000 });
        } else {
          window.addEventListener("load", () => setTimeout(loadThirdPartyScripts, 0), {
            once: true,
          });
        }
      }
    